import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import API_URLS from "../../Utils/axr";
import {getNotification
} from "../../../../shared/hooks/useFetchNotifications";
import store from "../store";
import {
  shouldSkipFailedOutApiFetch,
  shouldStopApiRetry,
  logApiRetryCapDwLog,
} from "../../Utils/utils";
import { EC_DW_LOGGING_STEPS } from "../../../../shared/utils/Constants";
type notificationInitialStateType = {
  notificationViewSortedData: any[];
  notificationArr: any[];
  isReaded: boolean;
  isMsgReaded: number;
  notificationResult?: any;
  notificationLoading:boolean;
  notificationError?:any;
  notificationPanelData?:any;
  payNowNotificationBtnClicked: boolean;
  pauseRetryNotificationBtnClicked: boolean;
  fetched: boolean;
  retryCount: number;
};
const initialState: notificationInitialStateType = {
  notificationViewSortedData: [],
  notificationArr: [],
  isReaded: false,
  isMsgReaded: -1,
  notificationResult: null,
  notificationLoading:false,
  notificationError:null,
  notificationPanelData:[],
  payNowNotificationBtnClicked: false,
  pauseRetryNotificationBtnClicked: false,
  fetched: false,
  retryCount: 0,
};

export const getNotificationByBan = createAsyncThunk(
  "notification/byban",
  async (banNumber: any) => {
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      const ban = banNumber || reduxStore?.user?.loginUserBan;
      /* In case if need to pass serive addressid to API. 
      const addId = reduxStore?.user?.loginUserAddressId;
       &addressId=${addId} */
      const response = await getNotification(
        {
          [API_URLS?.accountManagementUrl]: `ban-notification?ban=${ban}`, 
          
        },
        headers
      );
      return response?.data;
    } catch (error) {
      throw error;
    }
  },
  {
    condition: (_, { getState }) => {
      const state = (getState() as any)?.notificationDetails;
      if (state?.notificationLoading) {
        return false;
      }
      if (shouldSkipFailedOutApiFetch(!!state?.notificationResult, state?.fetched)) {
        return false;
      }
      return true;
    },
  }
);
const notificationSlice = createSlice({
  name: "notification/Details",
  initialState,
  reducers: {
    setNotificationModelSortedData: (state, action) => {
      state.notificationViewSortedData = action.payload;
    },
    setNotificationPanelData:(state,action)=>{
      state.notificationPanelData = action.payload;
    },
    updateNotificationModelSortedData: (state, action) => {
      //state.notificationViewSortedData = action.payload;
    },
    setIsReaded: (state, action) => {
      state.isReaded = action.payload;
    },
    setIsMsgReaded: (state, action) => {
      state.isMsgReaded = action.payload;
    },
    setPayNowNotificationBtnClicked: (state, action) => {
      state.payNowNotificationBtnClicked = (action.payload);
    },
    setPauseRetryNotificationBtnClicked: (state, action) => {
      state.pauseRetryNotificationBtnClicked = action.payload;
    },
    setNotification: (state, action) => {
      state.notificationArr.push(action.payload);
    },
    clearNotification: (state) => {
      state.notificationArr = [];
      state.notificationViewSortedData = [];
    },
    notificationSliceSetInitialState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getNotificationByBan.pending, (state) => {
      state.notificationLoading = true;
    });
    builder.addCase(getNotificationByBan.fulfilled, (state, action) => {
      state.notificationResult = action.payload;
      state.notificationLoading = false;
      state.notificationError = null;
      state.retryCount = 0;
      state.fetched = true;
    });
    builder.addCase(getNotificationByBan.rejected, (state, action) => {
      state.notificationLoading = false;
      state.notificationError = action.error;
      state.retryCount += 1;
      if (shouldStopApiRetry(state.retryCount)) {
        state.fetched = true;
        logApiRetryCapDwLog(
          EC_DW_LOGGING_STEPS.ban_notification_API_retry_cap,
          action.error?.message
        );
      }
    });
  }
});

export const {
  setNotificationModelSortedData,
  updateNotificationModelSortedData,
  setNotification,
  clearNotification,
  setPayNowNotificationBtnClicked,
  setPauseRetryNotificationBtnClicked,
  setIsReaded,
  setIsMsgReaded,
  notificationSliceSetInitialState,
  setNotificationPanelData
} = notificationSlice.actions;
export default notificationSlice.reducer;
